module.exports = __webpack_public_path__ + "static/img/s-logo-13.a9cc7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s-logo-13.png
// module id = 408
// module chunks = 2